<!--
 * @Author: your name
 * @Date: 2020-08-13 16:31:46
 * @LastEditTime: 2022-12-10 09:52:13
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay-ment/index.vue
-->
<style scoped lang="sass">
// Pre-mounted payment field that is not the selected method: keep it RENDERED (so the gateway's
// hosted-field iframe loads in the background at page load) but invisible and out of flow. Using
// display:none (v-show) instead would make the iframe load at height 0, so revealing it later
// would not be instant. Off-screen + visibility:hidden keeps a real width for correct iframe
// layout. ::v-deep so it applies to EachPayment's .additional_container too (Square mount point).
::v-deep .gateway-field--armed
  position: absolute !important
  left: -99999px !important
  top: 0
  width: 100%
  visibility: hidden

.choosed
  background: #f0fafa

.top
  padding-top: 13PX

.amount_pay
  padding-left: 17PX
  color: var(--menu-primary-text-colour) !important

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

.footer_common
  position: fixed
  bottom: 0

.tab_payment
  position: relative

.tab_pay
  display: flex
  align-items: center
  height: 75PX
  padding-left: 17PX
  background: #fff

.tab_pay_title
  height: 47PX
  width: calc(100%)
  padding-left: 17PX
  line-height: 47PX
  font-size: 14PX
  border-bottom: 0.02778rem solid #f1f2f3
  color: #334455 !important
  background-color: #f9f9f9

.create_tab_button
  height: auto
  border: none
  padding: 0 10PX
  border-radius: 5PX !important
  font-size: 14PX
  height: 35PX

.threeDS-popup
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  height: 58px
  line-height: 58px
  background: var(--menu-header-background-colour)
  color: var(--menu-header-colour)

  .arrow_left
    height: 45px
    width: 45px
</style>

<template lang="pug">
  .payment
    .overflow_scroll
      div(id="container")
      .top
        amount-pay.amount_pay(:totalPrice="realPrice")
        template(v-for="(item, i) in srcList")
          EachPayment.p(
            v-if="!item.unShow && enableShowPayment(item) && showPayType(item) && !useAirwallexUI"
            :key="item.id"
            :src="item.pic"
            :name="item.name"
            :choosed="i === index"
            :class="{'choosed': i === index, 'tab_payment': item.value === 'tabPay'}"
            @clickItem="choose(i)"
            :id="item.value"
          )
            template(v-slot:button)
              div.tab_pay(v-if="item.value === 'tabPay' && !tabInfo.currentTab && isEnableTab")
                van-button.create_tab_button.b(type="primary" @click="createTab") {{ t('start_a_tab', 'START A TAB') }}
            template(v-slot:title)
              div.tab_pay_title(v-if="item.value === 'tabPay'") {{ t('already_set_up_tab', 'Already set up a tab?') }}
          //- Adyen card fields render directly under the Credit Card row. Always rendered (so the
          //- hosted-field iframe mounts + loads at init, off-screen); revealed instantly when the
          //- Credit Card row is selected. NOT v-show (display:none breaks iframe load) — see
          //- .gateway-field--armed (off-screen + visibility:hidden, keeps real width).
          #card-payment-adyen.adyen-inline(
            v-if="item.value === 'creditCard'"
            :class="{ 'gateway-field--armed': !(enableAdyenPayment && paymentType === 'creditCard') }"
            :key="'adyen-' + item.id"
          )
        #payment-request-button
        #airwallex-dropIn(@onReady="handleAirwallexReady" @onSuccess="handleAirwallexSuccess" @onError="handleAirwallexError")
        #card-payment-adyen-applepay(v-show="enableAdyenPayment && paymentType === 'adyenApplePay'")
        #card-payment-adyen-googlepay(v-show="enableAdyenPayment && paymentType === 'adyenGooglePay'")

    footer-common.footer_common(@clickButton="clickButton" :text="payButtonText" :disabled="index < 0" v-if="!useAirwallexUI" )
    bottom-popup-dialog(
      v-model="showDialog"
      :show-close-icon="showCloseIcon"
      :dialog-height="dialogHeight"
      :showPopupLoading="showPopupLoading"
    )
      template(v-slot:popup-dialog)
        tip-content(
          :total="realPrice"
          :percent-list="tipPercentList"
          :disabledNextButton="disabledNextButton"
          @closeDialog="closeDialog"
          @choosed="getChoosedInfo"
          @clickNextButton="clickPopupNextButton"
        )
    add-tab-dialog(
      v-model="showAddTab"
      :currentTab="tabInfo.currentTab"
      :orderAmount="realPrice"
      @payWithTab="payWithTab"
    )
    tab-manage-popup-dialog(
      v-model="showPayErrorDialog"
      :title="showPayErrorDialogSettings.title"
      :content="showPayErrorDialogSettings.content"
      :first-button-text="showPayErrorDialogSettings.firstButtonText"
      :second-button-text="showPayErrorDialogSettings.secondButtonText"
      isFlexColumn
      showIcon
      @clickHandlerFirstButton="retryPay"
      @clickHandlerSecondButton="_restorePayErrorDialogDefaults"
    )

    mu-dialog( transition="fade" fullscreen :open.sync="show3dsIframe" v-loading="iframeLoading" )
      mu-appbar(color="primary" class="threeDS-popup" :title="t('verification_process', 'Verification Process')" )
        img.arrow_left(slot="left"
          src="@/assets/navPic/arrow_left.png"
          @click="show3dsIframe = false"
        )
      friendly-iframe(frame-id="threeDS_iframe" name="3ds iframe" :src="iframeUrl" @load="iframeLoading = false" @finish="finishIframeChecking")

    mu-dialog( transition="fade" fullscreen :open.sync="showAdyen3ds" )
      mu-appbar(color="primary" class="threeDS-popup" :title="t('verification_process', 'Verification Process')" )
        img.arrow_left(slot="left"
          src="@/assets/navPic/arrow_left.png"
          @click="closeAdyen3ds"
        )
      #adyen-3ds-container
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import EachPayment from './component/EachPayment'
import AmountPay from 'components/AmountPay'
import resizeHandler from 'utils/resizeHandler'
import {
  addOrder,
  addVenueSubGroupOrder,
  checkOrderPayment,
  getOrder,
  getUser,
  getUserOrders,
  getVenue,
  payOrder,
  payVenueSubGroupOrder,
  updateOrder,
} from 'api/product'
import axios from 'axios'
import TipContent from './component/TipContent'
import AddTabDialog from './component/AddTabDialog'
import { loading } from 'utils/decorators'
import { mapState } from 'vuex'
import { isAndroid, isIOS } from '@/utils/navigator'
import { delineryAddress } from 'utils/message'
// load airwallex component
import { createElement as createAirwallexElement, loadAirwallex } from 'airwallex-payment-elements'
import {
  initializeSquarePayments,
  squareBindType,
  squareCreatePayment,
  squareHandleSubmit,
  squareVerifyDetail
} from '@/utils/squarePayment'
import { initializeAdyenCheckout, bindAdyenCard, bindAdyenWallet, preloadAdyenSdk } from '@/utils/adyenPayment'
import { t } from '@/utils/language'
import { orderAmountNow, subGroupOrderAmountNow, ensureSubGroupSurchargeSources } from '@/utils/surchargeSnapshot'
import { getVenueQuietly } from '@/api/venueQuiet'
import { deliveryFeeFor } from '@/utils/deliveryFee'
import { tipAmountFor } from '@/utils/feeChain'
import { withOrderMenu } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { stopOrderingForPreview } from '@/utils/menu/previewOrderBlock'

const baseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0
}
const allowedCardNetworks = ['JCB', 'MASTERCARD', 'VISA', 'AMEX']
const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS']
const tokenizationSpecification = {
  type: 'PAYMENT_GATEWAY',
  parameters: {
    gateway: 'fatzebra', // This is our gateway   // 此为我方使用的 gateway
    gatewayMerchantId: 's2p-mondoconnex-2d328b68d524d6c1' // This is our ID   // 此为我方使用的 id
  }
}
const windcaveTokenSpecification = {
  type: 'PAYMENT_GATEWAY',
  parameters: {
    gateway: 'windcave', // This is our gateway
    gatewayMerchantId: 's2p-mondoconnex-2d328b68d524d6c1' // This is our ID
  }
}
const airwallexTokenSpecification = {
  type: 'PAYMENT_GATEWAY',
  parameters: {
    gateway: 'airwallex', // This is our gateway
    gatewayMerchantId: 'acct_4401MxmPMI6EmTv27DRTeA' // This is our ID - au based
  }
}

const baseCardPaymentMethod = {
  type: 'CARD',
  parameters: {
    allowedAuthMethods: allowedCardAuthMethods,
    allowedCardNetworks: allowedCardNetworks
  }
}

let paymentsClient = null

function getGoogleIsReadyToPayRequest() {
  return Object.assign({},
    baseRequest, {
      allowedPaymentMethods: [baseCardPaymentMethod]
    }
  )
}

function getGooglePaymentDataRequest(gateway, currency) {
  const paymentDataRequest = Object.assign({}, baseRequest)
  const gatewaySpecification = gateway === 'windcave' ? windcaveTokenSpecification : (gateway === 'airwallex' ? airwallexTokenSpecification : tokenizationSpecification)
  if (currency && currency === 'NZD' && gateway === 'airwallex') {
    // nz airwallex eneity
    gatewaySpecification.parameters.gatewayMerchantId = 'acct_vgfwFT7OMnmFsubJ7o25SQ'
  }

  const cardPaymentMethod = Object.assign({},
    baseCardPaymentMethod, {
      tokenizationSpecification: gatewaySpecification
    }
  )

  paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod]
  paymentDataRequest.transactionInfo = getGoogleTransactionInfo()
  paymentDataRequest.merchantInfo = {
    // @todo a merchant ID is available for a production environment after approval by Google
    // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
    // merchantId: '01234567890123456789',
    merchantId: 'BCR2DN6TROEPXAT4', // This is our ID   // 我方使用的 id
    merchantName: 'Mondo Menu' // menu
  }
  return paymentDataRequest
}

function getGooglePaymentsClient() {
  if (paymentsClient === null) {
    const PRODUCTION_ENV = 'production'
    const currentEnv = process.env.VUE_APP_ENV

    let environment = 'TEST'
    if (currentEnv === PRODUCTION_ENV) {
      environment = 'PRODUCTION'
    }
    console.log('currentGooglePayModel', environment)
    paymentsClient = new window.google.payments.api.PaymentsClient({
      environment: environment
    })
  }
  return paymentsClient
}

async function onGooglePayLoaded() {
  try {
    const paymentsClient = getGooglePaymentsClient()
    const response = await paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
    if (response.result) {
      console.log('可以使用google pay')
      return true
      // @todo prefetch payment data to improve performance after confirming site functionality
      // @todo In the late product environment, prefech is required to speed up loading
      // @todo 后期 product 环境，需要 prefech 用来加快加载速度
      // prefetchGooglePaymentData();
    }
  } catch (error) {
    console.log(error)
  }
}

function getGoogleTransactionInfo(realPrice, orderId, self) {
  return {
    // The actual item details are only for testing, and actually do not need to be added
    // 现实的 item 细节，这里只是测试，实际不用加入
    displayItems: [{
      label: t('subtotal', 'Subtotal'),
      type: 'SUBTOTAL',
      price: String(realPrice),
    }
    ],
    // Fixed items from here on
    // 从这开始为固定项目
    transactionId: String(orderId), // Order ID
    countryCode: self?.$store?.state.venueHome.venueCountry.toUpperCase(), // Country code   // 国家代码
    currencyCode: self?.$store?.state.currency.toUpperCase(), // Country currency code - determined according to the Venue setting   // 国家货币代码 - 根据 venue 的设定来定
    totalPriceStatus: 'FINAL', // Fixed as final, so the price will not be changed   // 固定为 final，这样价钱就不会变动
    totalPrice: String(realPrice),
    totalPriceLabel: t('total', 'Total')
  }
}

function prefetchGooglePaymentData(gateway, currency) {
  const paymentDataRequest = getGooglePaymentDataRequest(gateway, currency)
  // transactionInfo must be set but does not affect cache
  paymentDataRequest.transactionInfo = {
    totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
    currencyCode: this.$store.state.currency.toUpperCase()
  }
  const paymentsClient = getGooglePaymentsClient()
  paymentsClient.prefetchPaymentData(paymentDataRequest)
}

@Component({
  inject: ['name', 'reload'],

  requiredComponents: ['vant-base', 'muse-ui', 'vant-form', 'global-popup'],

  props: {
    venueSubGroupId: {
      type: String
    }
  },

  computed: {
    ...mapState({
      isOnline: state => state.app.isOnline,
      spDiscounts: state => state.spDiscounts,
      isEnableTab: state => state.enableTab,
      deliverySetting: state => state.venueHome.deliverySetting,
      deliveryInfo: state => state.contactDetails?.deliveryInfo[state.venueId] ?? {},
      _venueEnablePaymentGateway: state => state.venueHome?.enablePaymentGateway ?? {},
    }),

    enablePaymentGateway() {
      if (this.isSubgroupPayment || this.venueSubGroupId) {
        const subGroupId = this.venueSubGroupId || this.$store.state.venueHome.subGroupId
        const settings = this.$store.state.venueHome.subGroupSettings?.[subGroupId]?.settings
        if (settings?.enablePaymentGateway) return settings.enablePaymentGateway
      }
      return this._venueEnablePaymentGateway
    },

    payButtonText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const payTextTypes = ['applePay', 'googlePay', 'counterPay', 'adyenApplePay', 'adyenGooglePay']
      return payTextTypes.includes(this.selectedPaymentType) ? t('pay', 'PAY') : t('next', 'NEXT')
    },

    tabInfo() {
      return this.$store.getters.tabInfo(this.venueId)
    },

    venueId() {
      return this.$store.state.venueId
    },

    // 当前是否是 SP 模式
    isSpMode() {
      return this.$route.path.includes('/v/sp/') || this.$route.meta?.isSpMode === true
    },

    paymentType() {
      // index === -1 means nothing is selected yet (no default). Guard the [-1] lookup.
      if (this.index < 0 || !this.srcList[this.index]) return ''
      return this.srcList[this.index].value
    },

    venueName() {
      return this.$store.state.navTitle.venueName
    },

    venueInfoRequestStatus() {
      return this.$store.state.app.request
    },

    allowCounterPay() {
      return this.$store.state.app.allowCounterPay
    },

    counterPayName() {
      return this.$store.state.app.counterPayName
    },

    userId() {
      return localStorage.getItem('userId')
    },

    isPostPaidOrder() {
      return this.$store.state.venueHome.routerInfo.paymentType === 'post-paid'
    },

    enableShowStartTabButton() {
      const isTabOwner = this.tabInfo.currentTab?.id
      const isPostPaidOrder = this.isPostPaidOrder
      if (!this.$store.state.enableTab) return false
      return !isTabOwner || isPostPaidOrder
    },

    baseFee() {
      // 与购物车报的、总额里加的是同一个数（utils/deliveryFee.js；缺 type / 第三方没报价照后端按 0，review 第 1 轮 #6）
      return deliveryFeeFor(this.deliverySetting, this.deliveryInfo)
    },

    // Process the data structure returned by vuex and assign it to the itemList of the addOrder interface
    // 处理 vuex 返回的数据结构，赋值给 addOrder 接口的 itemList
    addItemlist() {
      const itemList = this.$store.getters.itemList(this.venueId).map(item => {
        if (item.comboProducts) {
          return {
            ...item,
            // ComboProducts needs to remove the modifications
            // comboProducts 需要去掉配菜
            comboProducts: this.deleteDuplicate(item.comboProducts.filter(e => e.type !== 'optional'), item.addList.filter(item => item.type !== 'oneProduct' && item.type !== 'optional'), item.removeList),
            addList: item.addList.filter(item => item.type !== 'oneProduct'),
          }
        } else {
          return item
        }
      })
      return itemList
    },

    subGroupCart() {
      if (this.isSubgroupPayment) {
        const cartList = this.$store.getters.venueSubGroupItemList(this.venueSubGroupId)
        for (var i in cartList) {
          if (cartList[i].cart) {
            cartList[i].cart = cartList[i].cart?.map(item => {
              if (item.comboProducts) {
                return {
                  ...item,
                  // ComboProducts needs to remove the modifications
                  // comboProducts 需要去掉配菜
                  comboProducts: this.deleteDuplicate(item.comboProducts.filter(e => e.type !== 'optional'), item.addList.filter(item => item.type !== 'oneProduct' && item.type !== 'optional'), item.removeList),
                  addList: item.addList.filter(item => item.type !== 'oneProduct'),
                }
              } else {
                return item
              }
            })
          }
        }
        return cartList
      } else {
        return {}
      }
    },

    isSubgroupPayment() {
      return this.$route.name.includes('venue-sub-group') && this.venueSubGroupId
    }
  },

  components: {
    EachPayment,
    AmountPay,
    TipContent,
    AddTabDialog,
  },

  async mounted() {
    // 多版本菜单 B6（U-B6-3 验收 P2-1 / U-B6-2 review 第 1 轮 F9）：菜单预览页不能下单、不能付款 —— 一进付款页就停，什么都不加载：
    // 不建单、不初始化 Square / Adyen / Airwallex（Airwallex 的 drop-in 一挂上，顾客就能在里面直接付给 Airwallex）。
    // Apple Pay 走的是全局 axios，请求层的预览本地拦管不到它，所以只能在页面这一层拦。与购物车结账按钮同一个判断、同一句话
    if (stopOrderingForPreview(this.$route)) return
    await this.beforeMountedFunction()
    // Fix 3: pre-warm the Adyen SDK + CSS chunk as early as possible (fire-and-forget) so the
    // default card form mounts instantly when checkEnableAdyenPay runs later. Gated on adyen so
    // non-adyen venues never download the chunk (D7).
    if (this.enablePaymentGateway && this.enablePaymentGateway.type === 'adyen') preloadAdyenSdk()
    const currentEnv = process.env.VUE_APP_ENV
    console.log('currentEnv', currentEnv)

    const restrictShowPayButtonList = [
      'production',
    ]

    const BAN_PAYMENT_ENV = {
      BAN_APPLE_PAY_ENV_LIST: [],
      BAN_GOOGLE_PAY_ENV_LIST: []
    }

    const enableApplePay = _checkEnablePay(currentEnv, BAN_PAYMENT_ENV.BAN_APPLE_PAY_ENV_LIST)
    const enableGooglePay = _checkEnablePay(currentEnv, BAN_PAYMENT_ENV.BAN_GOOGLE_PAY_ENV_LIST)

    if (restrictShowPayButtonList.includes(currentEnv)) {
      await this.showPayButtonByDepends(enableApplePay, enableGooglePay)
    } else {
      // sureShowPayButtonList — wallets first, then Credit Card, then counter/tab (see data srcList).
      this.srcList = [
        {
          pic: require('@/assets/pay-methods/new-apple-pay.svg'),
          name: 'Apple Pay',
          value: 'applePay',
          unShow: false
        },
        {
          pic: require('@/assets/pay-methods/new-google-pay.svg'),
          name: 'Google Pay',
          value: 'googlePay',
          unShow: false
        },
        {
          pic: require('@/assets/pay-methods/creditcard.svg'),
          name: 'Credit Card',
          value: 'creditCard',
          unShow: false
        },
        {
          pic: require('@/assets/pay-methods/Pay-at-counter.svg'),
          name: this.counterPayName,
          value: 'counterPay',
          unShow: true
        },
        {
          pic: require('@/assets/pay-methods/tab-pay.png'),
          name: 'Pay with tab',
          value: 'tabPay',
          unShow: false
        }
      ]
    }
    this.checkIsAllowCounterPay()
    const notificationKey = localStorage.getItem('notificationKey') || ''
    this.userInfo = await getUser({
      id: this.userId,
      notificationKey: notificationKey
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    await this.checkTipping()
    this.checkEnableTapPay()
    this.$store.commit('closeLoading')

    // functions
    function _checkEnablePay(currentEnv, banEnvList, allowedVenueList = [], currentVenueId = '') {
      const isEnabledPay = !banEnvList.includes(currentEnv)
      const isAllowedVenue = allowedVenueList.includes(currentVenueId)
      return isEnabledPay || isAllowedVenue
    }

    await this.checkEnableSquarePay()
    await this.checkEnableAdyenPay()
    this.checkEnableAirwallexUIPay()

    // Adyen redirect 3DS fallback: the shopper returned from an external bank page and Adyen
    // appended ?redirectResult=... to our returnUrl (/v/{venue}/payment?orderId&orderNo). Finish
    // the payment via /payments/details (adyenPayOrder posts stateData.details → backend
    // submitPaymentDetails). Run this AFTER full payment-method init (srcList + checkEnableAdyenPay)
    // so that if the bank auth FAILED, payFail leaves the shopper on a fully usable payment page
    // (card form mounted) to retry — not a half-initialized page where only wallets work.
    const adyenRedirectResult = this.$route.query.redirectResult
    if (adyenRedirectResult) {
      await this.adyenPayOrder(this.orderId || this.createOrderId, 'card', { stateData: { details: { redirectResult: adyenRedirectResult } } })
    }

    if (this.$openreplayTracker) this.$openreplayTracker.event('start_payment')
    if (this.$gtag) {
      this.$gtag.event('start_payment', {
        event_category: 'purchase_journey',
        event_label: 'Checkout - Payment Detail',
      })
    }
  },

  beforeDestroy() {
    // 清理 3DS iframe 加载状态，避免组件销毁时 v-loading 指令报错
    this.iframeLoading = false
    this.show3dsIframe = false
    if (this.adyenPolling && this.adyenPolling.timer) clearTimeout(this.adyenPolling.timer)
  }
})

class Payment extends mixins(mixin, resizeHandler) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // special for pre-paid order tip paid condition, because post-paid will never add-order, only will get-order.
  prePaidOrderHasPaidTip = false
  // for all tip paid condition
  hasPaidTip = false

  show3dsIframe = false // common 3ds iframe
  iframeUrl = 'about:blank'
  iframeLoading = false
  appleSession = null

  showDialog = false
  showCloseIcon = false
  dialogHeight = 44
  showPopupLoading = false
  disabledNextButton = true
  tipAmount = 0
  tipRate = 0
  enableTip = false
  showAddTab = false
  userInfo = {}
  orderType = ''
  gateway = ''

  selectedPaymentType = ''
  realPrice = 0
  createOrderId = ''
  createOrderNo = ''
  orderNo = ''
  orderId = ''
  index = -1 // no payment method selected by default (was 0 = auto-select first row)
  times = 0
  detailsShow = true
  isPhone = true
  useAirwallexUI = false // use airwallex element to pay or not
  useWindcaveAjaxPost = false // use windcave ajax post to pay or not
  airwallexConfig = {
    intentId: '',
    currency: this.$store.state.currency.toUpperCase(),
    clientSecret: '',
    customerId: '',
    testMode: true
  }

  enableSquarePayment = false
  squarePayment = {
    payment: null,
    card: null,
    // Bare (unattached) card instance for charging the saved card with SCA (B2); created lazily on first use.
    cardOnFile: null,
    applePay: null,
    googlePay: null,
    appLocationId: null,
    saveCard: null
  }

  enableAdyenPayment = false
  adyenPayment = {
    checkout: null,
    card: null,
    applePay: null,
    googlePay: null,
    clientKey: null,
    environment: 'test',
    savedCard: null
  }

  showAdyen3ds = false
  adyenPolling = { timer: null, attempts: 0 }

  // Order: wallets (Apple/Google) first, then Credit Card, then counter/tab. Rows are
  // added/toggled by VALUE (replacePayMethod / removePayMethod), never by hardcoded index,
  // so this order can change without breaking the enable/insert logic.
  srcList = [
    {
      pic: require('@/assets/pay-methods/new-apple-pay.svg'),
      name: 'Apple Pay',
      value: 'applePay',
      unShow: true
    },
    {
      pic: require('@/assets/pay-methods/new-google-pay.svg'),
      name: 'Google Pay',
      value: 'googlePay',
      unShow: true
    },
    {
      pic: require('@/assets/pay-methods/creditcard.svg'),
      name: 'Credit Card',
      value: 'creditCard',
      unShow: false
    },
    {
      pic: require('@/assets/pay-methods/Pay-at-counter.svg'),
      name: this.counterPayName,
      value: 'counterPay',
      unShow: true
    },
    {
      pic: require('@/assets/pay-methods/tab-pay.png'),
      name: 'Pay with tab',
      value: 'tabPay',
      unShow: true
    }
  ]

  showPayErrorDialog = false
  payErrorType = null
  // Default copy of the payment-failed dialog. The live settings object below is mutated by callers
  // (_deliveryInfoError, _showSavedCardCheckFailed) and restored from here when the dialog closes.
  payErrorDialogDefaults = {
    title: t('payment_failed', 'Payment failed'),
    content: t('payment_problem_retry', 'We had a problem processing your payment. Would you like to retry?'),
    firstButtonText: t('retry', 'Retry'),
    secondButtonText: t('cancel', 'Cancel'),
  }

  showPayErrorDialogSettings = { ...this.payErrorDialogDefaults }

  _restorePayErrorDialogDefaults() {
    this.savedCardCheckFailed = false
    Object.assign(this.showPayErrorDialogSettings, this.payErrorDialogDefaults)
  }

  // True while the saved-card verification dialog is the one on screen. Its "Try again" is passive (see
  // retryPay); the generic Square "Retry" dialog keeps re-running the payment.
  savedCardCheckFailed = false

  // Saved-card verification did not complete (B2): Square could not verify the stored card with the bank,
  // or the customer closed the 3DS challenge. Nothing was charged and no request reached our backend.
  // Both buttons only close the dialog (owner 2026-09-04: passive — no automatic re-run); the customer taps
  // PAY again to re-run the check, or picks "New Credit Card" in the list to pay with a different card.
  _showSavedCardCheckFailed() {
    // A challenge that fails after the customer navigated away must not touch the global loading state
    // of whatever page they are on now.
    if (this._isDestroyed) return
    this.savedCardCheckFailed = true
    this.showPayErrorDialogSettings.title = t('saved_card_check_failed', 'Couldn\'t verify your saved card')
    this.showPayErrorDialogSettings.content = t('saved_card_check_failed_hint', 'We couldn\'t confirm your saved card with your bank. Nothing has been charged. Please try again, or choose New Credit Card to pay with a different card.')
    this.showPayErrorDialogSettings.firstButtonText = t('try_again', 'Try again')
    this.showPayErrorDialogSettings.secondButtonText = t('cancel', 'Cancel')
    this.showPayErrorDialog = true
    this.$store.commit('closeLoading')
  }

  // Repayment
  // 重新支付
  retryPay() {
    const orderId = this.orderId || this.createOrderId

    if (this.enableAdyenPayment) {
      // Card is reset to 'ready' on failure; just dismiss the dialog so the shopper can re-enter
      // and tap Pay again on the same order (no separate retry call needed for Adyen).
      this.showPayErrorDialog = false
      this.resetAdyenCardStatus()
      return
    }

    if (this.enableSquarePayment) {
      // The dialog closes itself; the default copy comes back so a later, unrelated failure does not show
      // the saved-card wording. Saved-card "Try again" is passive by decision (owner 2026-09-04): nothing is
      // re-run, the customer taps PAY again or picks "New Credit Card". The generic "Would you like to
      // retry?" dialog (backend rejection / transport failure) still really retries, as shipped in B2.
      const savedCardDialog = this.savedCardCheckFailed
      this._restorePayErrorDialogDefaults()
      if (savedCardDialog) return
      this.clickButton()
      return
    }

    if (!this.payErrorType) {
      this.counterPay(orderId)
    } else if (this.payErrorType === 1) {
      this.onGooglePaymentButtonClicked(String(this.realPrice), orderId, this)
    } else if (this.payErrorType === 2) this.payWithTab()
  }

  // Receive 3 arrays and remove objects containing brr and crr from arr
  // 接收 3 个数组，去掉 arr 中包含 brr 和 crr 的对象
  deleteDuplicate(arr, brr, crr) {
    const c = []
    const y = []
    arr.forEach((item) => {
      const check = brr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        c.push(item)
      }
    })
    c.forEach((item) => {
      const check = crr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        y.push(item)
      }
    })
    return y
  }

  /**
   * Whether to display the payment type
   * @param item {Object} Payment Type Information
   * @returns {Boolean} Whether to display the payment type
   */
  /**
   * 是否显示支付类型
   * @param item {Object} 支付类型信息
   * @returns {Boolean} 是否显示支付类型
   */
  showPayType(item) {
    // If it is the delivery environment
    // 若是外卖环境
    if (this.isOnline) {
      return item.value === 'creditCard' || item.value === 'applePay' || item.value === 'googlePay' || item.value === 'adyenApplePay' || item.value === 'adyenGooglePay' || (item.value === 'counterPay' && this.orderType === 'pickup')
    }
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/vgs/o/') || this.$route.path.includes('/online/')
    // In the takeaway environment, tabPay is not displayed
    // 若是 takeaway 环境，不展示 tabPay
    if (isTakeaway) {
      return item.value !== 'tabPay'
    }
    return true
  }

  enableShowPayment(payment) {
    const banIsTabOwnerPaymentValueList = [
      'tabPay'
    ]
    if (banIsTabOwnerPaymentValueList.includes(payment.value) && !this.enableShowStartTabButton) {
      return false
    } else {
      return true
    }
  }

  createTab() {
    this._jumpToStartTab()
  }

  _jumpToStartTab() {
    if (this.isPostPaidOrder) {
      this.$router.push({
        path: `/v/${this.venueId}/tab-user/start-tab`,
        query: {
          orderId: this.orderId,
          orderNo: this.orderNo
        }
      })
    } else {
      this.$router.push(`/v/${this.venueId}/tab-user/start-tab`)
    }
  }

  async checkTipping() {
    this.isSubgroupPayment ? await this.__getVenueSubGroupOpenTime() : await this.__getVenueOpenTime()
    const enableVenueTipping = this.enableTipping
    const notHasPaidTip = !this.hasPaidTip
    if (enableVenueTipping && notHasPaidTip && !this.isOnline && this.realPrice > 0) this.showPopupDialog()
  }

  showPopupDialog() {
    this.$store.commit('closeLoading')
    this.showDialog = true
  }

  closeDialog(enableTip = false) {
    this.showDialog = false
    this.saveTipInfo(this.tipAmount, enableTip, this.tipRate)
  }

  saveTipInfo(tipAmount, enableTip, tipRate) {
    this.$store.commit('saveTipInfo', {
      prop: 'tipAmount',
      val: tipAmount
    })
    this.$store.commit('saveTipInfo', {
      prop: 'enableTip',
      val: enableTip
    })
    this.$store.commit('saveTipInfo', {
      prop: 'tipRate',
      val: tipRate
    })
  }

  getChoosedInfo(index) {
    // 按数值算：弹窗只报下标（显示串带本地化小数点，EUR 的 '5,16' 被 parseFloat 成 5，审计 UL-8）
    this.tipAmount = tipAmountFor(this.tipPercentList[index], this.realPrice)
    this.tipRate = this.tipPercentList[index]
    this.disabledNextButton = false
  }

  @loading('showPopupLoading')
  async clickPopupNextButton() {
    this.enableTip = true
    await this.updateOrder()
    setTimeout(() => {
      this.reload()
      // animate finished time
      // @todo assure the animate time to proof clike next or pay botton
    }, 300)
    this.closeDialog(true)
  }

  async updateOrder() {
    const tipInfo = {
      enableTip: this.enableTip,
      tipAmount: this.tipAmount,
      tipRate: this.tipRate
    }
    const data = {
      details: tipInfo,
      orderId: this.orderId || this.createOrderId,
      userId: localStorage.getItem('userId')
    }
    console.log(data)
    await updateOrder(data).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
  }

  // Replace a payment-method row found by its `value` (Vue-reactive via splice). Appends if absent.
  // Used instead of hardcoded srcList indices so row ORDER can change freely.
  replacePayMethod(value, entry) {
    const idx = this.srcList.findIndex(i => i.value === value)
    if (idx >= 0) {
      this.srcList.splice(idx, 1, entry)
    } else {
      this.srcList.push(entry)
    }
  }

  checkIsAllowCounterPay() {
    if (this.allowCounterPay) {
      this.replacePayMethod('counterPay', {
        pic: require('@/assets/pay-methods/Pay-at-counter.svg'),
        name: this.counterPayName,
        value: 'counterPay',
        unShow: false
      })
    }
  }

  checkEnableTapPay() {
    if (this.enableTab) {
      this.replacePayMethod('tabPay', {
        pic: require('@/assets/pay-methods/tab-pay.png'),
        name: 'Pay with tab',
        value: 'tabPay',
        unShow: false
      })
    }
  }

  async checkEnableSquarePay() {
    const production = this.enablePaymentGateway.enable ?? false
    const gateway = this.enablePaymentGateway.type
    const locationId = this.enablePaymentGateway.locationId ?? null
    if (gateway === 'square') {
      try {
        this.$store.commit('showLoading')
        this.enableSquarePayment = true
        const {
          payment,
          appLocationId
        } = await initializeSquarePayments(production, locationId)
        this.squarePayment.payment = payment
        this.squarePayment.appLocationId = appLocationId

        // check exist credit card token
        if (this.userInfo?.payment?.type && this.userInfo.payment.token && this.userInfo.payment.token.length > 0) {
          const tempPaymentOption = {
            pic: require('@/assets/pay-methods/creditcard.svg'),
            name: this.userInfo.payment.type + ' &#183;&#183;&#183;&#183 ' + this.userInfo.payment.creditCard.card,
            value: 'squareSavingCreditCard',
            unShow: false
          }
          // Rename the CARD row, found by value: srcList is wallets-first, so srcList[0] is the Apple Pay row and
          // renaming it by index mislabelled Apple Pay as "New Credit Card" whenever a saved card was offered.
          const creditCardRow = this.srcList.find(item => item.value === 'creditCard')
          if (creditCardRow) creditCardRow.name = 'New Credit Card'
          this.squarePayment.saveCard = this.userInfo.payment
          this.srcList.unshift(tempPaymentOption)
        }

        // bind card
        this.squarePayment.card = await squareBindType(this.squarePayment.payment, 'card', 'card-payment-creditCard')
        console.log('Square initialized with current environment')
      } catch (error) {
        this.enableSquarePayment = false
        console.error('Failed to initialize Square:', error)
      }

      if (this.enableSquarePayment === true) {
        // create payment request
        try {
          const countryCode = this.$store?.state.venueHome.venueCountry.toUpperCase() ?? 'AU' // Country code   // 国家代码
          const currencyCode = this.$store?.state.currency.toUpperCase() ?? 'AUD' // Country currency code - determined according to the Venue setting   // 国家货币代码 - 根据 venue 的设定来定

          this.squarePayment.paymentRequest = await squareCreatePayment(this.squarePayment.payment, countryCode, currencyCode, this.realPrice)
        } catch (error) {
          console.error('Failed to initialize Square applePay or googlePay:', error)
        }

        // bind google pay and apple pay
        if (this.squarePayment.paymentRequest) {
          try {
            // bind apple pay
            if (isIOS() && this.srcList.find(item => item.value === 'applePay')) {
              this.squarePayment.applePay = await squareBindType(this.squarePayment.payment, 'applePay', 'card-payment-applePay', this.squarePayment.paymentRequest)
            } else {
              this.srcList = this.srcList.filter(item => item.value !== 'applePay')
            }
          } catch (error) {
            console.error('Failed to initialize Square applePay or googlePay:', error)
            this.srcList = this.srcList.filter(item => item.value !== 'applePay')
          }

          try {
            // bind google pay
            if (isAndroid && this.srcList.find(item => item.value === 'googlePay')) {
              this.squarePayment.googlePay = await squareBindType(this.squarePayment.payment, 'googlePay', 'card-payment-googlePay', this.squarePayment.paymentRequest)
            } else {
              this.srcList = this.srcList.filter(item => item.value !== 'googlePay')
            }
          } catch (error) {
            console.error('Failed to initialize Square applePay or googlePay:', error)
            this.srcList = this.srcList.filter(item => item.value !== 'googlePay')
          }
        }
      }

      this.$store.commit('closeLoading')
    }
  }

  async checkEnableAdyenPay () {
    if (this.enablePaymentGateway.type !== 'adyen') return // lazy-load guard (D7)
    try {
      this.$store.commit('showLoading')
      this.enableAdyenPayment = true
      this.adyenPayment.clientKey = this.enablePaymentGateway.clientKey
      this.adyenPayment.environment = this.enablePaymentGateway.environment || 'test'

      const countryCode = (this.$store?.state.venueHome.venueCountry || 'NZ').toUpperCase()
      const currency = (this.$store?.state.currency || 'NZD').toUpperCase()
      const value = Math.round(parseFloat(this.realPrice) * 100) // minor units

      // Saved card → render our own one-click option (mirrors Square's saved-card unshift).
      const adyenSaved = this.userInfo && this.userInfo.payment && this.userInfo.payment.adyen
      if (adyenSaved && adyenSaved.storedPaymentMethodId) {
        this.adyenPayment.savedCard = adyenSaved
        this.srcList.unshift({
          pic: require('@/assets/pay-methods/creditcard.svg'),
          name: 'Saved card ···· ' + (adyenSaved.last4 || ''),
          value: 'adyenSavedCard',
          unShow: false
        })
      }

      this.adyenPayment.checkout = await initializeAdyenCheckout({
        clientKey: this.adyenPayment.clientKey,
        environment: this.adyenPayment.environment,
        amount: { currency, value },
        countryCode,
        onSubmit: (state) => {
          const payType = (this.paymentType === 'adyenApplePay' || this.paymentType === 'adyenGooglePay') ? 'wallet' : 'card'
          return this.adyenPayOrder(this.orderId || this.createOrderId, payType, { stateData: state.data })
        },
        onAdditionalDetails: (state) => {
          const payType = (this.paymentType === 'adyenApplePay' || this.paymentType === 'adyenGooglePay') ? 'wallet' : 'card'
          return this.adyenPayOrder(this.orderId || this.createOrderId, payType, { stateData: state.data })
        },
        onError: (err) => { console.error('Adyen error:', err); this.payFail() }
      })
      this.adyenPayment.card = bindAdyenCard(this.adyenPayment.checkout, '#card-payment-adyen', { styles: this.adyenCardStyle() })
      // Accent (focus border / save-card checkbox) follows the venue theme colour — same
      // source as Square. Bridged into adyenTheme.css via a CSS custom property because
      // Adyen's `styles` object only reaches the text inside the secured-field iframes.
      const adyenCardEl = document.querySelector('#card-payment-adyen')
      if (adyenCardEl) adyenCardEl.style.setProperty('--adyen-theme-color', this.adyenThemeColor())
      // Wallets (Apple Pay / Google Pay): Adyen wallet components on the shared checkout. We do NOT
      // render Adyen's own wallet button (showPayButton:false in bindAdyenWallet) — the unified bottom
      // CTA drives submit via clickButton, exactly like the card. Each wallet is isAvailable()-gated.
      // Amount accuracy: the sheet shows walletCfg.amount; the only amount-changing action (tip) runs
      // updateOrder() → reload() (injected; re-mounts) → checkEnableAdyenPay() again, so it stays fresh.
      // First drop the static (Square-era) applePay/googlePay rows so an adyen venue doesn't show dead
      // duplicates next to the real Adyen wallets.
      this.srcList = this.srcList.filter(i => i.value !== 'applePay' && i.value !== 'googlePay')
      const walletEntries = []
      const walletCfg = {
        amount: { currency, value },
        configuration: {
          merchantName: this.enablePaymentGateway.merchantName || 'MondoMenu',
          gatewayMerchantId: this.enablePaymentGateway.merchantAccount, // Google Pay
          ...(this.enablePaymentGateway.merchantId ? { merchantId: this.enablePaymentGateway.merchantId } : {}) // Apple Pay (only if not Adyen-managed)
        }
      }
      try {
        this.adyenPayment.applePay = await bindAdyenWallet(this.adyenPayment.checkout, 'applepay', '#card-payment-adyen-applepay', walletCfg)
        walletEntries.push({ pic: require('@/assets/pay-methods/new-apple-pay.svg'), name: 'Apple Pay', value: 'adyenApplePay', unShow: false })
      } catch (e) {
        console.log('Adyen Apple Pay unavailable:', e && e.message)
      }
      try {
        // v5.72: 'paywithgoogle' is the canonical/internal type ('googlepay' is an accepted alias).
        this.adyenPayment.googlePay = await bindAdyenWallet(this.adyenPayment.checkout, 'paywithgoogle', '#card-payment-adyen-googlepay', walletCfg)
        walletEntries.push({ pic: require('@/assets/pay-methods/new-google-pay.svg'), name: 'Google Pay', value: 'adyenGooglePay', unShow: false })
      } catch (e) {
        console.log('Adyen Google Pay unavailable:', e && e.message)
      }
      // Wallets go to the TOP of the list (above Credit Card). There is no default selection
      // anymore (index === -1), so nothing auto-selects a wallet; the shopper taps to choose.
      if (walletEntries.length) {
        this.srcList.unshift(...walletEntries)
      }
    } catch (e) {
      this.enableAdyenPayment = false
      console.error('Failed to initialize Adyen:', e)
    } finally {
      this.$store.commit('closeLoading')
    }
  }

  // Resolve the venue theme colour. Same source the Airwallex theme and the app-wide
  // buttonColor() use: the brand colour in the store → the CSS variable App.vue sets on
  // <body> → a teal default. Fed into adyenTheme.css via --adyen-theme-color.
  adyenThemeColor () {
    const appColor = this.$store && this.$store.state && this.$store.state.app && this.$store.state.app.color
    const c = (appColor && appColor.menu_primary_background_colour) ||
      getComputedStyle(document.body).getPropertyValue('--menu-primary-background-colour') ||
      '#14C4BC'
    return (c + '').trim()
  }

  // Styles the text INSIDE Adyen's secured-field iframes (card number / expiry / security code).
  // The field border + checkbox accent are themed separately via --adyen-theme-color, because
  // Adyen's styles object only reaches the iframe text, not the field border in our DOM.
  adyenCardStyle () {
    return {
      base: {
        color: '#333333',
        fontSize: '16px',
        fontFamily: 'inherit'
      },
      placeholder: {
        color: '#bbbbbb'
      },
      error: {
        color: '#e2554f'
      }
    }
  }

  async checkEnableAirwallexUIPay() {
    if (this.useAirwallexUI) {
      this.$store.commit('showLoading')
      const self = this
      const currentEnv = process.env.VUE_APP_ENV
      const PRODUCTION_ENV = 'production'
      const env = currentEnv === PRODUCTION_ENV ? (this.airwallexConfig.testMode === true ? 'demo' : 'prod') : 'demo'

      // Add Step: check airwallex is paid or not
      console.log('start check airwallex intent is paid or not')
      const config = { ...this.airwallexConfig }

      const res = await getOrder({
        id: this.orderId || this.createOrderId,
        getAirwallexResult: true,
        airwallexConfig: config
      }).catch(error => {
        console.log(error)
      })
      console.log(res)
      if (res.status === 'SUCCEEDED') {
        this._handleAirwallexPay(res)
      }

      loadAirwallex({
        env: env, // Can choose other production environments, 'staging | 'demo' | 'prod'
        origin: window.location.origin, // Setup your event target to receive the browser events message
        // For more detailed documentation at https://github.com/airwallex/airwallex-payment-demo/tree/master/docs#loadAirwallex
      }).then(() => {
        // STEP #4: Create the drop-in element
        const element = createAirwallexElement('dropIn', {
          // Required, dropIn use intent Id, client_secret and currency to prepare checkout
          intent_id: this.airwallexConfig.intentId,
          client_secret: this.airwallexConfig.clientSecret,
          currency: this.airwallexConfig.currency,
          customer_id: this.airwallexConfig.customerId,
          methods: ['card', 'applepay', 'googlepay'],
          mode: 'payment',
          // if you want to use apple pay, please pass merchant country code in applePayRequestOptions
          applePayRequestOptions: {
            countryCode: 'NZ' // force to use NZ temporary
          },
          // if you want to use google pay, please pass merchant country code in googlePayRequestOptions
          googlePayRequestOptions: {
            countryCode: 'NZ', // force to use NZ temporary
          },
          theme: {
            palette: {
              primary: self.$store.state.app.color.menu_primary_background_colour, // brand color, the default value is #612FFF
            }
          }
        })
        // STEP #5: Mount the drop-in element to the empty container created previously
        element.mount('airwallex-dropIn') // This 'dropIn' id MUST MATCH the id on your empty container created in Step 3
      })
    }
  }

  handleAirwallexReady(event) {
    this.$store.commit('closeLoading')
    console.log('ready', event)
  }

  handleAirwallexSuccess(event) {
    console.log('success', event)
    this._handleAirwallexPay(event.detail.intent)
  }

  handleAirwallexError(event) {
    console.log('pay-order airwallex fail')
    console.log('error', event)
    this.payFail()
  }

  async _handleAirwallexPay(data) {
    const self = this
    self.$store.commit('showLoading')
    // show returned data in developer console for debugging
    const paymentData = { ...data }
    // Request the pay-order interface
    // 请求 pay-order 接口
    console.log('send back airwallex pay order')
    await self.airwallexPayOrder({
      orderId: self.orderId || self.createOrderId,
      detail: paymentData
    })
  }

  async airwallexPayOrder({
    orderId,
    detail
  }) {
    const data = {
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      useAirwallexUI: true,
      airwallexInfo: detail,
      paymentInfo: {}
    }
    const self = this
    try {
      const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder
      const res = await payOrderFun(data).catch(error => {
        console.log(error)
        this._deliveryInfoError(error)
        this.showPayErrorDialog = true
        this.payErrorType = 1
        this.$store.commit('closeLoading')
      }).then(res => {
        if (res && res.paymentStatus === 1) {
          console.log('pay-order success')
          // console.log(res)
          self.paySuccess()
        } else {
          console.log('pay-order fail')
          self.payFail()
          this.$router.replace(this.$route.fullPath + '&timestamp=' + Date.now())
        }
      }).catch(error => {
        console.log('pay-order fail')
        console.log(error)
        self.payFail()
        // retry the pay order
        // refresh current page
        this.$router.replace(this.$route.fullPath + '&timestamp=' + Date.now())
      })
    } catch (error) {
      console.log('pay-order fail')
      console.log(error)
      // retry the pay order
      // refresh current page
      self.payFail()
      await this.$router.replace(this.$route.fullPath + '&timestamp=' + Date.now())
    }
  }

  async _filterAndSaveUnfinishOrder() {
    // filter and save unOverOrders
    if (this.userId) {
      await this._updateUnfinishOrders()
    } else {
      if (this.isSubgroupPayment) {
        this.$store.commit('clearUnpaidVenueSubgroupOrder', this.venueSubGroupId)
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    }
  }

  async _updateUnfinishOrders() {
    const orders = await this._getUserUnOverOrders('nostart_all')
    const ordersTotal = parseInt(orders.total)
    if (this.isSubgroupPayment) {
      if (ordersTotal > 0) {
        const filtersOrder = orders.orders.filter(item => {
          if (item.paymentStatus === 0 && item.status <= 40) {
            return item
          }
        })
        if (filtersOrder.length > 0) {
          const order = filtersOrder[0]
          this.prePaidOrderHasPaidTip = order.details.enableTip
          this._updateVenueSubgroupUnpaidOrderList(order.id, order.orderNo)
        } else {
          this.$store.commit('clearUnpaidVenueSubgroupOrder', this.venueSubGroupId)
        }
      } else {
        this.$store.commit('clearUnpaidVenueSubgroupOrder', this.venueSubGroupId)
      }
    } else {
      if (ordersTotal > 0) {
        const filtersOrder = orders.orders.filter(item => {
          if (item.paymentStatus === 0 && item.status <= 40) {
            return item
          }
        })
        if (filtersOrder.length > 0) {
          const order = filtersOrder[0]
          // PrePaidOrderHasPaidTip of unpaid order
          // 未付款的 order 的 prePaidOrderHasPaidTip
          this.prePaidOrderHasPaidTip = order.details.enableTip
          this.saveVenueUnpaidOrderList(order.id, order.orderNo)
        } else {
          this.$store.commit('clearUnpaidOrder', this.venueId)
        }
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    }
  }

  _updateVenueSubgroupUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueSubgroupUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  saveVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: this.venueId ?? 'unknown',
      venueSubGroupId: this.venueSubGroupId ?? null,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  async showPayButtonByDepends(enableApplePay, enableGooglePay) {
    if (isIOS() && enableApplePay) {
      await this.startLoadApplePay()
    } else if (isAndroid() && enableGooglePay) {
      await this.startLoadGooglePay()
    } else {
      // Do not show
      // 都不显示
      // It is isAndroid or isIOS, but the corresponding payment is not allowed
      // 是 isAndroid 或者 isIOS，但是都不允许对应的支付
    }
  }

  async startLoadApplePay() {
    const enableShowApplePay = await this.loadApplePay()
    if (enableShowApplePay) {
      this.replacePayMethod('applePay', {
        pic: require('@/assets/pay-methods/new-apple-pay.svg'),
        name: 'Apple Pay',
        value: 'applePay',
        unShow: false
      })
    }
  }

  async startLoadGooglePay() {
    const enableShowGooglePay = await this.loadGooglePay()
    if (enableShowGooglePay) {
      this.replacePayMethod('googlePay', {
        pic: require('@/assets/pay-methods/new-google-pay.svg'),
        name: 'Google Pay',
        value: 'googlePay',
        unShow: false
      })
    }
  }

  async loadGooglePay() {
    /**
     * Process explanation
     * 1. The demo here calls onGooglePayLoaded when the api js file of google pay is read
     * 2. In onGooglePayLoaded, generate paymentsClient first, and call paymentsClient to determine whether you can google pay
     * 3. If you can google pay, add a button to the webpage, bind the webpage and click: at this time, load the order related information, and call payment
     * 4. When the payment is successful, it is actually not. At this time, a token (actually the encrypted information of a credit card or bank card) is generated. The token is transmitted to the background (the api has been updated) through pay-order, and the background processes it like a creditcard
     * For the following specific instructions, please refer to the relevant documents of Google Pay：https://developers.google.com/pay/api/web/guides/tutorial
     **/
    /**
     * 流程解释
     * 1. 这里的 demo 是当 google pay 的 api js 文件读取时候，调用 onGooglePayLoaded
     * 2. 在 onGooglePayLoaded 里，生成 paymentsClient，然后通过调用 paymentsClient 判断是否可以 google pay
     * 3. 如果可以 google pay，则添加 button 到网页，并且绑定网页。点击：这时候载入订单相关信息，并且调用支付
     * 4. 当支付成功的时候，生成 token（实际是信用卡或者银行卡的加密信息），token 通过 pay-order 传输到后台（已更新 api），由后台进行处理类似 creditcard
     * 以下具体说明可以参考 google pay 的相关文档：https://developers.google.com/pay/api/web/guides/tutorial
     **/
    console.log('load google pay')
    const res = await onGooglePayLoaded()
    if (res) return true
  }

  onGooglePaymentButtonClicked(realPrice, orderId, self) {
    console.log('trigger click google pay事件')
    const paymentDataRequest = getGooglePaymentDataRequest(this.gateway, this.$store.state.currency.toUpperCase())
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo(realPrice, orderId, self)
    console.log(paymentDataRequest)
    const paymentsClient = getGooglePaymentsClient()
    paymentsClient.loadPaymentData(paymentDataRequest)
      .then(function (paymentData) {
        // handle the response
        self.processPayment(paymentData)
      })
      .catch(function (err) {
        // show error in developer console for debugging
        console.error(err)
        self.payFail()
      })
  }

  async processPayment(paymentData) {
    const self = this
    self.$store.commit('showLoading')
    // show returned data in developer console for debugging
    console.log(paymentData)
    // @todo pass payment token to your gateway to process payment
    // After getting the token, you can now pay order for the next step
    // 拿到 token，现在可以进行下一步 pay-order 了
    const paymentToken = paymentData.paymentMethodData.tokenizationData.token
    // Request the pay-order interface
    // 请求 pay-order 接口
    self.googlePayOrder({
      orderId: self.orderId || self.createOrderId,
      token: paymentToken
    })
  }

  async beforeMountedFunction() {
    /**
     * 1. To summarize, the change is the change of the create-order position of the pre-paid
     *  original:
     *    create-order is created by clicking Pay
     *  Now:
     *    Entering the select payment method will create a new order. This includes refreshing the page, or entering the select payment method again after returning to the cart page.
     * 2. Set the reason for creating an order when entering the page if it is pre paid:
     *  When the user selects a product and adds a cart, he arrives at the select payment method page. At this time, he does not choose to pay, but wants to add another product in the product or edit cart,
     *  at this time, he will go back to the cart page, edit it, and then enter the select payment method page. A new order will be generated, and then he can choose to pay, or continue to go back to the cart,
     *  or go back to the venue-home and click on several products, and then pay the order. This is normal user behavior.
     * 3. Problems caused by this setting:
     *  The core problem is that a pre aid user may create-order many times, but only pay-order once. In addition, only the last create-order before pay-order is the order the user wants
     *  The current process is that as long as the user creates an order, the management background will receive an order. For the pre paid user, only the order after the pay-order is the order that the user places an order
     * 4. Suggestions for solving problems
     *  For pre paid users, the management background will display the order of the user's order only after the pay-order, rather than create-order.
     */
    /**
     * 1. 概括一下改动就是 pre-paid 的 create-order 位置的改变
     *  原来：
     *    create-order 是点击，支付才会 create-order
     *  现在：
     *    进入select payment method 会 create-order，是一定会创建一个 new order。包括刷新页面，或者返回到 cart 页面之后再次进入 select payment method。
     * 2. 设置。如果是 pre-paid，进入页面就 create-order 的原因：
     *  当用户选择一个 product 并 add cart，到达 select payment method 页面，此时他并没有选择支付，而是想再加一个 product 或者 edit cart 中的 product，
     *  此时他会回退到 cart 页面，然后编辑之后再进入 select payment method 页面，会生成一个 new order，然后他可以选择支付，或者继续回退到 cart 中，
     *  或者回退到 venue-home 再点几个 product，然后再支付 order。这样是正常的用户行为。
     * 3. 这种设置带来的问题：
     *  核心问题就是，可能一个 pre-paid 用户 create-order 很多次，而只是 pay-order 一次。而且，只有 pay-order 之前的最近一次的 create-order 是用户想要的 order。
     *  现在的流程是，只要用户 create-order，管理后台就会收到一个 order，而对于 pre-paid 用户来讲，只有 pay-order 之后的 order 才是用户下单的 order
     * 4. 解决问题的建议
     *  如果是 pre-paid 的用户，只有 pay-order 之后，管理后台才会显示用户点餐的 order，而不是 create-order 就显示。
     */
    this.$store.commit('showLoading')
    await this._filterAndSaveUnfinishOrder()
    this._setShowMask()
    // Get OrderId
    // 获取 OrderId
    const forceNew = !!this.$route.query.new
    delete this.$route.query.new
    await this.getOrderId(forceNew)
    await this._setOrderPrice()
  }

  async _setOrderPrice() {
    // Get the total price in order
    // 获取 order 中的 total price
    const price = await this._getOrderPrice()
    this.realPrice = price
  }

  async _getOrderPrice() {
    const orderId = this.orderId || this.createOrderId
    if (!orderId) return
    const res = await getOrder({
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      startPayment: true
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.orderType = res.details?.orderType ?? 'dine-in'
    this.hasPaidTip = res.details?.enableTip ?? false
    this.useAirwallexUI = res.details?.enableAirwallexUI ?? false
    if (this.useAirwallexUI) {
      this.airwallexConfig.clientSecret = res.details.airwallexConfig.clientSecret
      this.airwallexConfig.intentId = res.details.airwallexConfig.intentId
      this.airwallexConfig.currency = res.details.airwallexConfig.currency
      this.airwallexConfig.customerId = res.details.airwallexConfig.customerId
      this.airwallexConfig.testMode = res.details.airwallexConfig.testMode
      // this.airwallexConfig.consentId = res.details.airwallexConfig.consentId ?? null
    }
    this.useWindcaveAjaxPost = res.details?.enableWindcaveAjaxPost ?? false
    this.gateway = res.gateway ?? ''

    return res.amount
  }

  async getOrderId(forceNew) {
    // Get the query to determine the paymentType
    // 获取 query 来判断是 paymentType
    this.orderNo = this.$route.query.orderNo
    this.orderId = this.$route.query.orderId

    // If it is post-paid
    // 如果是 post-paid
    // Post payment does not generate an order, just continue to pass orderId and orderNo
    // 后付款不生成 order，继续传递 orderId 与 orderNo 即可
    if (this.orderNo && this.orderId) {
    } else {
      // pre-paid
      // if the createOrderId and the createOrderNo all exist then didnt create new order
      // 先付款一定生成 order
      let unPaidOrderNo = ''
      let unPaidOrderId = ''
      if (this.isSubgroupPayment) {
        const index = this.$store.state.venueHome.venueSubgroupUnpaidOrderList.findIndex(item => item.venueSubGroupId === this.venueSubGroupId)
        if (index !== -1) {
          unPaidOrderNo = this.$store.state.venueHome.venueSubgroupUnpaidOrderList[index].unPaidOrderId
          unPaidOrderId = this.$store.state.venueHome.venueSubgroupUnpaidOrderList[index].unPaidOrderNo
        }
      } else {
        const index = this.$store.state.venueUnpaidOrderList.findIndex(item => item.venueId === this.venueId)
        if (index !== -1) {
          unPaidOrderNo = this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
          unPaidOrderId = this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
        }
      }
      if (!unPaidOrderNo) {
        // If there is no unpaid order, createOrder
        // 如果没有未支付的 order，那就 createOrder
        console.log('create order')
        if (this.isOnline && this.deliveryInfo.orderType === 'delivery') {
          const isPass = await this._verifyUserPostcode()
          if (!isPass) {
            const self = this
            this.$createTabMessageDialog({
              $props: delineryAddress,
              $events: {
                click() {
                  self._jumpToCart()
                },
              },
            }).show()
            return
          }
        }
        const res = await this.createOrder()
        if (this.isOnline && !res) return
        this.createOrderId = res.id
        this.createOrderNo = res.orderNo
        if (res.paymentStatus === 1) this._jumpToOrder()
      } else {
        // If there is an unpaid order AddOrder
        // 如果有未支付的 order AddOrder
        if (this.prePaidOrderHasPaidTip && forceNew !== true) {
          // If the payment is not made, but the order for tip payment has been selected, the add order will not be add-order
          // 如果是未付款，但是已经选择支付 tip 的 order，不再 add-order
          this.createOrderId = unPaidOrderNo
          this.createOrderNo = unPaidOrderId
          return
        }
        if (this.isOnline && this.deliveryInfo.orderType === 'delivery') {
          const isPass = await this._verifyUserPostcode()
          if (!isPass) {
            const self = this
            this.$createTabMessageDialog({
              $props: delineryAddress,
              $events: {
                click() {
                  self._jumpToCart()
                },
              },
            }).show()
            return
          }
        }
        const res = await this.createOrder(unPaidOrderNo)
        if (this.isOnline && !res) return
        this.createOrderId = res.id
        this.createOrderNo = res.orderNo
        if (res.paymentStatus === 1) this._jumpToOrder()
      }
    }
  }

  // Verify whether the delivery address has changed
  // 校验外卖地址是否发生变化
  async _verifyUserPostcode() {
    let isPass = false
    const rawAddress = JSON.parse(this.deliveryInfo.rawAddress)
    const { address_components } = rawAddress
    let postcode
    address_components.forEach(address => {
      if (address.types && address.types.includes('postal_code')) postcode = address.short_name
    })
    if (postcode) {
      const venueInfo = await getVenue({
        id: this.venueId
      })
      let postcodes = venueInfo?.settings?.deliverySettings?.areaSettings?.postcodes ?? []
      if (postcodes?.length) {
        postcodes = postcodes.map(item => ({
          ...item,
          zone: item?.name ?? item.zone,
          postcode: item?.postalcode ?? item.postcode
        }))
      }
      isPass = !!postcodes.find(item => item.postcode === postcode)
    }
    return isPass
  }

  _jumpToOrder(orderId, orderNo) {
    this.clearProductListAndUnpaidOrder()
    this.$router.push({
      path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/my-order/${this.createOrderId}` : `/v/${this.venueId}/my-order/${this.createOrderId}`,
      query: {
        orderNo: this.createOrderNo,
        // clearCart: true,
        isReadyTab: 1,
        isMarketing: 1
      }
    })
  }

  _saveVenueUnpaidOrderList() {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: this.createOrderId,
      unPaidOrderNo: this.createOrderNo,
    })
  }

  // If an error is reported in a third-party order, the showPayErrorDialogSettings error prompt is modified to the interface error message
  // 如果是第三方订单报错 showPayErrorDialogSettings，错误提示修改为接口报错信息
  _deliveryInfoError(error) {
    const isString = this._.isString(error)
    const deliveryInfo = this.deliveryInfo
    // The request layer rejects with `undefined` (network error / timeout) or an object (##thirdParty## delivery
    // errors), not only strings. Calling .includes on those threw inside the .catch, so the retry dialog that
    // the next three lines open never appeared — the customer only saw a toast and re-tapped PAY (B2 review).
    const isThirdPartyError = isString && error.includes('##thirdParty##')
    if (isThirdPartyError && deliveryInfo.orderType === 'delivery' && deliveryInfo?.deliveryCost?.totalCost) {
      this.showPayErrorDialogSettings.title = t('failed', 'Failed')
      if (isString) this.showPayErrorDialogSettings.content = error.replace('##thirdParty##', '')
    }
  }

  _jumpToCart() {
    const tableNumber = this.$store.state.venueHome.routerInfo.number || this.$route.query?.tableNumber
    if (tableNumber) {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/cart/t/${tableNumber}` : `/v/${this.venueId}/cart/t/${tableNumber}`
      })
    } else {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/cart/p` : `/v/${this.venueId}/cart/p`
      })
    }
  }

  // After order generation
  // 生成 order 后
  _setShowMask() {
    const status = localStorage.getItem('showMask')
    if (!status) localStorage.setItem('showMask', 'show')
  }

  choose(i) {
    this.index = i
    const type = this._getPaymentType(i)
    this._savePaymentType(type)
    this.selectedPaymentType = type
    // Wallet rows (Apple/Google Pay): tapping the row launches the sheet immediately — the
    // single-tap pattern Apple/Google both recommend. The bottom CTA still shows "PAY" for these
    // rows so the shopper can re-launch if they dismissed the sheet (see clickButton). The row tap
    // is a click-context user gesture, required for Apple Pay's ApplePaySession.
    this.launchAdyenWallet(type)
  }

  // Launch an Adyen wallet sheet synchronously (must stay in the click-event context for Apple
  // Pay). Called from both the row tap (choose) and the bottom PAY button (clickButton) so either
  // entry point works. No-op for non-wallet types or if the component isn't available.
  launchAdyenWallet(type) {
    if (!this.enableAdyenPayment) return false
    if (type === 'adyenApplePay' && this.adyenPayment.applePay) {
      this.adyenPayment.applePay.submit() // → wallet sheet → onSubmit → adyenPayOrder
      return true
    }
    if (type === 'adyenGooglePay' && this.adyenPayment.googlePay) {
      this.adyenPayment.googlePay.submit()
      return true
    }
    return false
  }

  _getPaymentType(index) {
    return this.srcList[index].value
  }

  _savePaymentType(paymentType) {
    this.$store.commit('savePaymentInfo', {
      prop: 'type',
      val: paymentType
    })
  }

  async counterPay(orderId) {
    const data = {
      id: orderId,
      paymentInfo: {
        type: 'payAtCounter'
      }
    }
    const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder
    await payOrderFun(data).catch(error => {
      console.log(error)
      this._deliveryInfoError(error)
      this.showPayErrorDialog = true
      this.payErrorType = 0
      this.$store.commit('closeLoading')
    })
  }

  /**
   * Apple Pay Order
   * @param params {Object} Interface parameter transfer
   * @param appleSession {Object} Application session
   */
  /**
   * 苹果支付订单
   * @param params {Object} 接口传参
   * @param appleSession {Object} 应用程序会话
   */
  async applePayOrder(params, appleSession) {
    const self = this
    // Call the pay-order interface
    // 调取 pay-order 接口
    self.appleSession = appleSession

    const payOrderUrl = self.isSubgroupPayment ? '/customer/default/pay-venue-sub-group-order' : '/customer/default/pay-order'
    axios
      .post(process.env.VUE_APP_BASE_API + payOrderUrl, params)
      .then(res => {
        if (res.data.success) {
          if (self.require3dsVerification(res.data)) {
            return
          }
          // Successful payment
          // 成功付款
          if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_SUCCESS)
          self.paySuccess()
          self.appleSession = null
        } else {
          // Unsuccessful payment
          // 未成功付款
          if (appleSession) appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE)
          self.payFail()
          self.appleSession = null
        }
      })
  }

  require3dsVerification(response) {
    this.$store.commit('closeLoading')
    if (response.redirectIframe && response.redirectIframe.length > 0) {
      this.iframeUrl = response.redirectIframe
      this.show3dsIframe = true
      this.iframeLoading = true
      return true
    }
    return false
  }

  openAdyen3ds (action) {
    this.$store.commit('closeLoading')
    this.showAdyen3ds = true
    this.$nextTick(() => {
      this.adyenPayment.checkout.createFromAction(action).mount('#adyen-3ds-container')
    })
  }

  closeAdyen3ds () {
    this.showAdyen3ds = false
  }

  async finishIframeChecking(event) {
    console.log(event)
    this.iframeUrl = 'about:blank'
    this.show3dsIframe = false
    this.iframeLoading = false
    if (event.finishVerification) {
      const orderId = this.orderId || this.createOrderId

      if (event.orderId.toString() === orderId.toString()) {
        // finish the payment
        if (this.appleSession) this.appleSession.completePayment(window.ApplePaySession.STATUS_SUCCESS)
        await this.paySuccess()
        this.appleSession = null
      }
    } else {
      // failed verification
      if (this.appleSession) this.appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE)
      this.payFail()
      this.appleSession = null
    }
  }

  displayIframeError(message) {
    this._deliveryInfoError(message)
    this.showPayErrorDialog = true
    this.$store.commit('closeLoading')
  }

  /**
   * @param {object} extraData the SDK tokenize result ({ status, token, … }) — on EVERY path, the saved card
   *   included (B2: card.tokenize(details{intent:CHARGE}, cardId) → fresh one-time token carrying the 3DS result)
   * @param {string|null} existingCardId saved-card path only: the `ccof:` card-on-file id that was charged. Sent as
   *   existToken so the backend knows not to store the card again and which card to keep as the saved one.
   *   Before B2 existToken WAS the charge source; now `token` charges and existToken is bookkeeping.
   */
  async squarePayOrder(orderId, type, extraData, existingCardId = null) {
    const token = extraData.token ?? null
    const data = {
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      paymentInfo: {
        ...this.$store.state.paymentInfo,
        type: 'square',
        token: token,
        paymentType: type,
        tokenRawData: extraData,
        locationId: this.squarePayment.appLocationId
      }
    }

    if (type === 'saveCard') {
      data.paymentInfo.existToken = existingCardId
    }

    const self = this
    delete data.paymentInfo.creditCard
    delete data.paymentInfo.transactionId
    delete data.paymentInfo.action
    try {
      const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder
      const res = await payOrderFun(data).catch(error => {
        console.log(error)
        this._deliveryInfoError(error)
        this.showPayErrorDialog = true
        this.payErrorType = 1
        this.$store.commit('closeLoading')
      }).then(res => {
        if (self.require3dsVerification(res)) {
          return // require 3ds verification
        }
        if (res && res.paymentStatus === 1) {
          console.log('pay-order success')
          // console.log(res)
          self.paySuccess()
        } else {
          console.log('pay-order fail')
          self.payFail()
        }
      }).catch(error => {
        console.log('pay-order fail')
        console.log(error)
        self.payFail()
      })
    } catch (error) {
      console.log('pay-order fail')
      console.log(error)
      self.payFail()
    }
  }

  async adyenPayOrder (orderId, type, extra) {
    const self = this
    this.$store.commit('showLoading') // covers the wallet path (CTA closed the overlay before the native sheet)
    const data = {
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      paymentInfo: {
        ...this.$store.state.paymentInfo,
        type: 'adyen',
        paymentType: type,
        // The backend reads these from paymentInfo (AdyenTool::payOrder + buildPayOrderOpts),
        // NOT from the top level. Nesting them is what lets /payments receive the real
        // paymentMethod object — otherwise it defaults to [] and Adyen rejects with
        // "Field 'paymentMethod' expected to be a Structure but is an Array".
        stateData: (extra && extra.stateData) || null,
        storedPaymentMethodId: (extra && extra.storedPaymentMethodId) || null,
        saveCard: !!(extra && extra.stateData && extra.stateData.storePaymentMethod)
      }
    }
    delete data.paymentInfo.creditCard
    delete data.paymentInfo.transactionId
    delete data.paymentInfo.action
    try {
      const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder
      const res = await payOrderFun(data).catch(error => {
        console.log(error)
        this._deliveryInfoError(error)
        this.showPayErrorDialog = true
        this.payErrorType = 1
        this.$store.commit('closeLoading')
        this.resetAdyenCardStatus() // unlock the card behind the error dialog
        return null
      })
      if (!res) return
      // 3DS / action required → hand the action to the Adyen component (Task 6).
      if (res.action) {
        this.openAdyen3ds(res.action)
        return
      }
      // Looks final (sync auth, or a 3DS continuation via onAdditionalDetails). Do NOT trust this
      // blindly — res.status is the order-workflow status and can be >= 10 even when payment failed,
      // which is what made 3DS failures land on the order page. Re-verify payment_status with the
      // backend before navigating (D5: never jump to the order page unconfirmed).
      if (res.paymentStatus === 1 || res.status >= 10 || res.status === -1) {
        await self.adyenFinalizeSuccess(orderId)
        return
      }
      // Not final yet (e.g. webhook still in flight) → poll fallback.
      self.startAdyenPolling(orderId)
    } catch (error) {
      console.log('adyen pay-order fail', error)
      self.payFail()
    }
  }

  startAdyenPolling (orderId) {
    const self = this
    const maxAttempts = 15 // ~15 × 2s ≈ 30s timeout (D5)
    this.adyenPolling.attempts = 0
    if (this.adyenPolling.timer) clearTimeout(this.adyenPolling.timer)
    this.$store.commit('showLoading') // "Confirming your payment…" overlay
    const tick = async () => {
      self.adyenPolling.attempts++
      try {
        // Sub-group orders MUST send type — the backend otherwise looks the id up in the
        // venue-order table (different id sequence) and the poll can never confirm payment.
        const res = await checkOrderPayment({ id: orderId, type: self.isSubgroupPayment ? 'venueSubGroupOrder' : '' })
        // check-order-payment nests the order under `order` (pay-order does not) — read both.
        const o = (res && res.order) || res || {}
        const paid = o.paymentStatus === 1 && (o.status >= 10 || o.status === -1)
        if (paid) {
          self.$store.commit('closeLoading')
          self.paySuccessJump() // already verified paid by the poll; jump straight (skip the stubbed re-check)
          return
        }
      } catch (e) {
        console.log('adyen poll error', e)
      }
      if (self.adyenPolling.attempts >= maxAttempts) {
        self.$store.commit('closeLoading')
        self.payFail() // fail loud → re-pay on the same order (D5/D6); never auto-jump to order page
        return
      }
      self.adyenPolling.timer = setTimeout(tick, 2000)
    }
    tick()
  }

  async googlePayOrder({
    orderId,
    token
  }) {
    const data = {
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      paymentInfo: {
        ...this.$store.state.paymentInfo,
        type: 'googlePay',
        token: token
      }
    }
    const self = this
    delete data.paymentInfo.creditCard
    delete data.paymentInfo.transactionId
    delete data.paymentInfo.action
    try {
      const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder
      const res = await payOrderFun(data).catch(error => {
        console.log(error)
        this._deliveryInfoError(error)
        this.showPayErrorDialog = true
        this.payErrorType = 1
        this.$store.commit('closeLoading')
      }).then(res => {
        if (self.require3dsVerification(res)) {
          return // require 3ds verification
        }
        if (res && res.paymentStatus === 1) {
          console.log('pay-order success')
          // console.log(res)
          self.paySuccess()
        } else {
          console.log('pay-order fail')
          self.payFail()
        }
      }).catch(error => {
        console.log('pay-order fail')
        console.log(error)
        self.payFail()
      })
    } catch (error) {
      console.log('pay-order fail')
      console.log(error)
      self.payFail()
    }
  }

  clearProductListAndUnpaidOrder() {
    if (this.isSubgroupPayment) {
      this.$store.commit('clearVenueSubGroupProductList')
    }
    this.$store.commit('clearProductList')
    this.$store.commit('clearDiscounts')
    // this.$store.commit('clearUnpaidOrder', this.venueId)
  }

  payWithTab() {
    this.$store.commit('showLoading')
    const orderId = this.orderId || this.createOrderId
    const orderNo = this.orderNo || this.createOrderNo
    payOrder({
      id: orderId,
      paymentInfo: {
        type: 'payWithTab',
        tabCode: this.userInfo.currentTab.tabCode
      }
    }).then(res => {
      this.clearProductListAndUnpaidOrder()
      this.$store.commit('closeLoading')
      this.$router.push({
        path: `/v/${this.$store.state.venueId}/tab-order-received/${orderId}`,
        query: {
          orderId,
          orderNo,
          isMarketing: 1
        }
      })
    }).catch(error => {
      this._deliveryInfoError(error)
      this.showPayErrorDialog = true
      this.payErrorType = 2
      this.$store.commit('closeLoading')
    })
  }

  // True while a payment attempt is in flight. The global loading overlay used to be the only thing
  // serialising attempts, and the saved-card path drops that overlay itself on a failed check — so a
  // Retry tap racing a still-running attempt could tokenize twice on the same card instance (B2 red team).
  paying = false

  async clickButton() {
    // 多版本菜单 B6（F9）：菜单预览页 ⇒ 弹那句、哪一种付款方式都不开始（包括走全局 axios 的 Apple Pay）
    if (stopOrderingForPreview(this.$route)) return
    // No method selected yet (index === -1): the CTA is disabled, but guard here too.
    if (this.index < 0) return
    if (this.paying) return
    this.paying = true
    this.$store.commit('showLoading')
    this.detailsShow = false
    try {
      const orderId = this.orderId || this.createOrderId
      if (this.enableSquarePayment) {
        let typeName = this.paymentType
        let passData = null
        let success = false
        const countryCode = this.$store?.state.venueHome.venueCountry.toUpperCase() ?? 'AU' // Country code   // 国家代码
        const currencyCode = this.$store?.state.currency.toUpperCase() ?? 'AUD' // Country currency code - determined according to the Venue setting   // 国家货币代码 - 根据 venue 的设定来定
        // Buyer name / email / phone go to Square's 3DS evaluation as billingContact (F1).
        const verifyDetail = squareVerifyDetail(countryCode, currencyCode, this.realPrice, this.$store?.state.contactDetails?.user ?? {})
        if (this.paymentType === 'creditCard') {
          typeName = 'card'
          passData = await squareHandleSubmit(this.squarePayment.payment, this.squarePayment[typeName], typeName, verifyDetail)
          // console.log(passData)
          if (passData.status === 'OK') success = true
        } else if (this.paymentType === 'squareSavingCreditCard') {
          // Saved card with SCA (B2, docs/plans/2026-09-03-square-card-on-file-3ds-b2.md): tokenize the
          // stored card so Square runs the buyer verification / 3DS challenge and the result rides on a
          // fresh one-time token into CreatePayment. Before B2 the card id itself was sent as the charge
          // source → an unverified ON_FILE charge, which Risk Manager's 3DS rule would decline.
          typeName = 'saveCard'
          const savedCardId = this.squarePayment.saveCard?.token ?? null
          // No card id → there is nothing to tokenize. Without this guard squareHandleSubmit would fall back to
          // the single-argument tokenize on the empty, unattached instance and, had that ever returned OK, the
          // backend would have seen existToken=null and treated the payment as a NEW card (CreateCard again).
          if (!savedCardId) {
            this._showSavedCardCheckFailed()
            return
          }
          try {
            if (!this.squarePayment.cardOnFile) {
              this.squarePayment.cardOnFile = await squareBindType(this.squarePayment.payment, 'cardOnFile')
            }
            const chargeDetail = squareVerifyDetail(countryCode, currencyCode, this.realPrice, this.$store?.state.contactDetails?.user ?? {}, 'CHARGE')
            passData = await squareHandleSubmit(this.squarePayment.payment, this.squarePayment.cardOnFile, 'card', chargeDetail, savedCardId)
            if (passData.status === 'OK') success = true
          } catch (error) {
            // Verification declined / challenge closed / SDK failure: nothing charged, nothing sent to the
            // backend. Tell the customer and let them retry or pick "New Credit Card".
            console.error('Square saved-card verification failed:', error)
            this._showSavedCardCheckFailed()
            return
          }
          // Never fall through to the shared squarePayOrder call below: it does not carry the card id, and a
          // silent non-OK result would otherwise leave the loading overlay up with nothing sent.
          if (success !== true) {
            this._showSavedCardCheckFailed()
            return
          }
          // The bank challenge is an unbounded await: if the customer left the page meanwhile, do not charge
          // and navigate them away from wherever they went — the fresh token simply expires unused.
          if (this._isDestroyed) return
          await this.squarePayOrder(orderId, typeName, passData, savedCardId)
          return
        } else if (this.paymentType === 'applePay') {
          typeName = 'applePay'
          passData = await squareHandleSubmit(this.squarePayment.payment, this.squarePayment[typeName], typeName, verifyDetail)
          if (passData.status === 'OK') success = true
        } else if (this.paymentType === 'googlePay') {
          typeName = 'googlePay'
          passData = await squareHandleSubmit(this.squarePayment.payment, this.squarePayment[typeName], typeName, verifyDetail)
          if (passData.status === 'OK') success = true
        }
        if (success === true) {
          await this.squarePayOrder(orderId, typeName, passData)
        }
      } else if (this.enableAdyenPayment) {
        const orderId = this.orderId || this.createOrderId
        if (this.paymentType === 'adyenSavedCard') {
          await this.adyenPayOrder(orderId, 'saveCard', { storedPaymentMethodId: this.adyenPayment.savedCard.storedPaymentMethodId })
        } else if (this.paymentType === 'adyenApplePay' || this.paymentType === 'adyenGooglePay') {
          // Re-launch the wallet sheet from the PAY button (e.g. shopper dismissed the auto-launch
          // from the row tap). Native sheet takes over → drop the overlay so cancel doesn't hang.
          this.$store.commit('closeLoading')
          this.launchAdyenWallet(this.paymentType)
        } else if (this.adyenPayment.card && this.adyenPayment.card.isValid) {
          this.adyenPayment.card.submit() // → onSubmit → adyenPayOrder (D1)
        } else {
          this.$store.commit('closeLoading')
          if (this.adyenPayment.card) this.adyenPayment.card.showValidation()
        }
      } else if (this.index >= 0 && this.paymentType !== 'creditCard') {
        // creditCard 走默认托管卡页(safe2pay/windcave),由下面的 else 跳 card-detail。
        // a4637c1e 把条件从 `this.index` 改成 `this.index >= 0` + 钱包重排序后,信用卡(不再是 index 0)
        // 会被这个分支截住而没有处理分支 → showLoading 永不关闭 → 无限转圈。排除 creditCard 即恢复原行为。
        if (this.useAirwallexUI) {
          await this._handleAirwallexPay()
        } else if (this.paymentType === 'googlePay') {
          this.onGooglePaymentButtonClicked(String(this.realPrice), orderId, this)
        } else if (this.paymentType === 'applePay') {
          console.log('apple pay')
          const applePayRequestInfo = {
            countryCode: this.$store.state.venueHome.venueCountry.toUpperCase(), // It has been synchronized as a venue country   // 已经同步为 venue country
            currencyCode: this.$store.state.currency.toUpperCase(), // It is not an interface acquisition, but is written to death when vuex is initialized   // 不是接口获取，而是 vuex 初始化时候写死的
            supportedNetworks: ['visa', 'masterCard', 'amex'],
            merchantCapabilities: ['supports3DS'],
            total: {
              label: `${this.venueName} - ${orderId}`,
              amount: String(this.realPrice)
            },
          }
          this.startApplePay(applePayRequestInfo, orderId)
        } else if (this.paymentType === 'counterPay') {
          console.log('counterPay')
          try {
            await this.counterPay(orderId)
            this.paySuccess()
          } catch (error) {
            console.log(error)
            this.payFail()
          }
        } else if (this.paymentType === 'tabPay') {
          this._handleClickTabPay()
        }
      } else {
        // 清理 3DS iframe 状态，避免导航时 v-loading 指令报错
        this.iframeLoading = false
        this.show3dsIframe = false

        this.$router.push({
          path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/card-detail` : `/v/${this.venueId}/card-detail`,
          query: {

            // Distinguish between pre-paid and post-paid. This is the query passed from post-paid paies
            // 区分 pre-paid and post-paid，这就是 post - paid 的 pay 时候，传递过来的 query
            orderNo: this.orderNo,
            orderId: this.orderId,

            // Distinguish between pre-paid and post pay. This is the case of pre-paid
            // 区分 pre-paid and post-paid，这就是 pre-paid 的情况
            createOrderId: this.createOrderId,
            createOrderNo: this.createOrderNo,
            useWindcaveAjaxPost: this.useWindcaveAjaxPost
          }
        })
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        this.$store.commit('closeLoading')
      }, 300)
    } finally {
      this.paying = false
    }
  }

  _handleClickTabPay() {
    // @todo get hasOpeningTab
    const currentTab = this.userInfo.currentTab
    if (this.isPostPaidOrder && currentTab) {
      if (!currentTab.isSetTabAmount || (currentTab.isSetTabAmount && Number(currentTab.amount) + Number(this.realPrice) > Number(currentTab.tabAmount))) {
        this._openAddTabDialog()
      } else {
        this.payWithTab()
      }
    } else {
      this._jumpToTabPay()
    }
  }

  _openAddTabDialog() {
    this.showAddTab = true
  }

  _jumpToTabPay() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-user/pay`,
      query: {
        hasPaidTip: this.hasPaidTip,
        orderId: this.orderId || this.createOrderId,
        orderNo: this.orderNo || this.createOrderNo
      }
    })
  }

  // Create Order
  // 创建订单
  async createOrder(unPaidOrderId) {
    const state = this.$store.state
    const getters = this.$store.getters
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不能靠对象字面量里键的先后（review 第 1 轮 #8）；
    // 多店按各成员店自己的配置重判（#5）；缺判定依据的成员店先补拉门店设置（Codex 第 2 轮 #3 / #4）
    if (this.isSubgroupPayment) await ensureSubGroupSurchargeSources(this.$store, { fetchVenue: getVenueQuietly })
    const amount = this.isSubgroupPayment ? subGroupOrderAmountNow(this.$store, this.venueSubGroupId) : orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.isSubgroupPayment ? getters.subGroupCartTotal(this.venueSubGroupId) : this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: {
        ...state.details,
        baseFee: this.baseFee,
        minDeliveryAmount: this.deliveryInfo.minDeliveryAmount,
      },
      type: state.type,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId ?? '',
      venueSubGroupId: this.isSubgroupPayment ? this.venueSubGroupId : '',
      itemList: this.isSubgroupPayment ? [] : this.addItemlist,
      // 合单（子组）明确不带优惠码（owner D71-8，2026-10-14）：多店付款走 add-venue-sub-group-order，固定发空
      spDiscounts: this.isSubgroupPayment ? [] : this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    // SP 模式下添加 spMode 参数
    if (this.isSpMode) {
      data.spMode = true
    }
    if (this.isSubgroupPayment) {
      data.cartList = this.subGroupCart
    }

    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    if (this.isOnline) {
      const deliveryInfo = this.deliveryInfo
      data.type = deliveryInfo.type
      data.user.address = deliveryInfo.rawAddress
      data.details.orderType = deliveryInfo.orderType
      data.details.googleDeliveryTime = deliveryInfo?.deliveryCost?.timeCost ?? deliveryInfo.googleDeliveryTime
      data.details.preOrderTimeSettings = (deliveryInfo.preOrderTimeSettings && deliveryInfo.preOrderTimeSettings !== 'Invalid Date') ? deliveryInfo.preOrderTimeSettings : ''
    }

    let res = null
    if (this.isSubgroupPayment) {
      // 合单这一轮不带菜单参数（D98①：成员店一律按主菜单）
      res = await addVenueSubGroupOrder(data)
    } else {
      res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route)))
    }
    return res
  }

  payFail() {
    console.log('支付失败')
    this.$store.commit('closeLoading')
    // Adyen: card.submit() locks the component into a disabled "processing" state until we report
    // a result; on failure we must reset it to 'ready' or the fields stay unclickable. Also closes
    // any open 3DS dialog so the shopper can retype and retry on the same order.
    this.resetAdyenCardStatus()
  }

  // Re-enable the Adyen card after a failed/abandoned attempt (and close the 3DS dialog).
  resetAdyenCardStatus() {
    if (this.showAdyen3ds) this.showAdyen3ds = false
    const card = this.adyenPayment && this.adyenPayment.card
    if (card && typeof card.setStatus === 'function') {
      try { card.setStatus('ready') } catch (e) { console.log('adyen setStatus error', e) }
    }
  }

  // Adyen-only completion gate (separate from the shared paySuccess/_circleCheckOrderPayStatus so
  // other gateways are untouched). Re-verifies with the backend that the order is truly paid before
  // navigating; otherwise fails loud and stays on the payment page to re-pay (D5). This is what stops
  // a 3DS failure from landing on the order page just because res.status (order workflow) was >= 10.
  async adyenFinalizeSuccess(orderId) {
    try {
      // Sub-group orders MUST send type — the backend otherwise looks the id up in the
      // venue-order table (different id sequence) and the re-verify would fail (or worse,
      // read a stranger's order) even though the group order is paid.
      const res = await checkOrderPayment({ id: orderId, type: this.isSubgroupPayment ? 'venueSubGroupOrder' : '' })
      // check-order-payment returns { order: { paymentStatus, status } } (nested), unlike
      // pay-order which returns the order fields at the top level. Read from `order` first,
      // falling back to the top level so both response shapes work.
      const o = (res && res.order) || res || {}
      const paid = o.paymentStatus === 1 && (o.status >= 10 || o.status === -1)
      if (paid) {
        this.$store.commit('closeLoading')
        this.paySuccessJump()
        return
      }
    } catch (e) {
      console.log('adyen finalize check error', e)
    }
    this.payFail()
  }

  async paySuccess() {
    console.log('支付成功')
    this.$store.commit('closeLoading')
    const res = await this._circleCheckOrderPayStatus()
    if (res) {
      this.paySuccessJump()
    } else {
      this.payFail()
    }
  }

  async _circleCheckOrderPayStatus() {
    return true
  }

  paySuccessJump() {
    console.log('jump')
    this.clearProductListAndUnpaidOrder()
    if (this.orderNo && this.orderId) {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/my-order/${this.orderId}` : `/v/${this.venueId}/my-order/${this.orderId}`,
        query: {
          orderNo: this.orderNo,
          isMarketing: 1
        }
      })
    } else {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/my-order/${this.createOrderId}` : `/v/${this.venueId}/my-order/${this.createOrderId}`,
        query: {
          orderNo: this.createOrderNo,
          isMarketing: 1
        }
      })
    }
  }

  // apple pay

  // Payment function
  // 支付函数
  startApplePay(applePayRequestInfo, orderId) {
    console.log('applePayRequestInfo', applePayRequestInfo)
    var currentAvailableApplePayVersion = 3
    for (let i = 3; i <= 25; i++) {
      if (window.ApplePaySession.supportsVersion(i)) {
        currentAvailableApplePayVersion = i
        break
      }
    }

    // Generate apple pay request
    // 生成 apple pay 请求
    // const request = {
    //   countryCode: 'AU', // country code - It is tentatively determined as au, because there is only Australia now, and it should be taken according to the setting of venue   // country code - 暂定为 au，因为现在只有澳洲，之后应该根据 venue 的设定来拿
    //   currencyCode: 'AUD', // currency code - It is tentatively determined as AUD, because there is only Australia now, and it should be taken according to the setting of venue   // currency code - 暂定为 AUD， 因为现在只有澳洲，之后应该根据 venue 的设定来拿
    //   supportedNetworks: ['visa', 'masterCard', 'amex'],
    //   merchantCapabilities: ['supports3DS'],
    //   total: {
    //     label: 'venue name - your order',
    //     amount: '10.00'
    //   },
    // }
    const session = new window.ApplePaySession(currentAvailableApplePayVersion, applePayRequestInfo)
    this._handleApplePayEvents(session, orderId) // Bind event to apple pay   // 绑定 event 给 apple pay
    session.begin() // start   // 开始
  }

  _handleApplePayEvents(appleSession, orderId) {
    console.log('_handleApplePayEvents')
    const self = this
    // Verify server information
    // 验证 server 信息
    appleSession.onvalidatemerchant = function (event) {
      const params = {
        id: orderId, // The correct order id is required   // 需要用正确的 order id
        url: event.validationURL,
        domain: location.host, // Front end domain   // 前端 domain
      }
      if (self.isSubgroupPayment) {
        params.venueSubGroupId = self.venueSubGroupId
      }

      // Convert params to query string
      // 将 params 转换成 query string
      // Apply for the actual session from the background
      // 从后台申请实际的 session
      const url = (self.gateway === 'windcave' || self.gateway === 'airwallex') ? '/customer/default/create-applepay-intent?' : '/customer/default/create-safe2way-applepay-intent?'
      axios
        .post(process.env.VUE_APP_BASE_API + url + new URLSearchParams(params).toString())
        .then(res => {
          console.log(res)
          if (res.data.success) {
            // Get a session and return it to apple session. This session can only be used once
            // 拿到 session，传回给 apple session，此 session 只能使用一次
            console.log('res success')
            if (res.data.data.merchantSession) {
              console.log('complete merchant')
              appleSession.completeMerchantValidation(res.data.data.merchantSession)
            } else {
              console.log(res.data)
            }
          }
        }).catch(error => console.log('error', error))
    }

    // After obtaining payment information successfully
    // 当获取付款信息成功后
    appleSession.onpaymentauthorized = function (event) {
      console.log('complete payment')
      const params = {
        id: orderId, // order id
        paymentInfo: {
          type: 'applePay',
          token: event.payment.token
        }
      }
      if (self.isSubgroupPayment) {
        params.venueSubGroupId = self.venueSubGroupId
      }
      self.applePayOrder(params, appleSession)
    }
  }

  async loadApplePay() {
    console.log('loadApplePay')
    const ApplePaySession = window.ApplePaySession
    if (window.ApplePaySession) {
      // When apple pay allows
      // 当 apple pay 允许的时候
      // Get the lowest version no at present, starting from 3. All the apple related apis below here can be queried from the official website
      // 获得当前最低的 version no，从 3 开始，此处之下的 apple 相关 api 都可以从官网查询内容
      // CurrentAvailableApplePayVersion is a global variable that needs to be used below, so it is declared with var
      // currentAvailableApplePayVersion 是全局变量，下面需要用到，所以用 var 声明
      var currentAvailableApplePayVersion = 3
      for (let i = 3; i <= 25; i++) {
        if (ApplePaySession.supportsVersion(i)) {
          currentAvailableApplePayVersion = i
          break
        }
      }

      const currentEnv = process.env.VUE_APP_ENV
      const PRODUCTION_ENV = 'production'
      // Display the button of apple pay
      // 显示 apple pay 的 button
      let merchantIdentifier = 'merchant.io.pmnts.sandbox.applepay.dq-mondo'
      if (currentEnv === PRODUCTION_ENV) merchantIdentifier = 'merchant.io.pmnts.production.applepay.s2p-mondoconnex'
      var promise = ApplePaySession.canMakePayments()
      try {
        const canMakePayments = await promise
        console.log('canMakePayments', canMakePayments)
        if (canMakePayments) return true

        // switch (canMakePayments.paymentCredentialStatus) {
        //   case 'paymentCredentialsAvailable':
        //     // Display an Apple Pay button and offer Apple Pay as the primary payment option.
        //     return true
        //   case 'paymentCredentialStatusUnknown':
        //     // Display an Apple Pay button and offer Apple Pay as a payment option.
        //     return true
        //   case 'paymentCredentialsUnavailable':
        //     // Consider displaying an Apple Pay button.
        //     return true
        //   case 'applePayUnsupported':
        //     // Don't show an Apple Pay button or offer Apple Pay.
        //     console.log('接口没通过验证，不显示apple pay')
        // }
        console.log('接口没通过验证，不显示apple pay')
      } catch (error) {
        console.log(error)
      }
    }
  }
}

export default Payment
</script>
